import React, { Component } from 'react'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import axios from 'axios'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import ClipLoader from 'react-spinners/ClipLoader'
import Inspector from './Inspector'
import NextButtons from './NextButtons'
import styles from './Test.css'

const PREPARE_INTERVAL_SEC = 3 // eslint-disable-line no-unused-vars
const CONFIRM_INTERVAL_SEC = 3 // eslint-disable-line no-unused-vars
const CONFIRM_INTERVAL_SEC_FOR_UNEXPECTED = 15 // eslint-disable-line no-unused-vars

function shuffle(array) {
  var currentIndex = array.length
  var temporaryValue
  var randomIndex

  // While there remain elements to shuffle...
  while (currentIndex !== 0) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex)
    currentIndex -= 1

    // And swap it with the current element.
    temporaryValue = array[currentIndex]
    array[currentIndex] = array[randomIndex]
    array[randomIndex] = temporaryValue
  }

  return array
}

class Test extends Component {
  constructor(props) {
    super(props)

    this.initialState = {
      choice: {},
      answers: [],
      activities: [],
      finished: false,
      input: '',
      selectedWord: null,
      selectedChunk: null,
      dictWords: null
    }
    this.state = Object.assign({}, this.initialState)
    this.textInputRef = React.createRef()
  }

  copyState() {
    const state = Object.assign({}, this.state)
    if (state.choice) {
      state.choice = {}
      Object.entries(this.state.choice).forEach((e) => {
        state.choice[e[0]] = Object.assign({}, e[1])
      })
    }
    if (state.answers) {
      state.answers = state.answers.map((a) => a)
    }
    state.activities = state.activities.map((a) => Object.assign({}, a))
    return state
  }

  recordActivity(action, callback) {
    const state = this.copyState()
    state.activities.push({
      time: Date.now(),
      action: action
    })
    this.setState(state, () => {
      if (this.props.onActivitiesRecorded) {
        this.props.onActivitiesRecorded(this.state.activities)
      }
      if (!callback) {
        return
      }
      callback()
    })
  }

  componentDidUpdate(prevProps, prevState) {
    this.initializeState(prevProps)
    this.updateFocus(prevState)
    this.checkAndNotifyAnswersAdded(prevState);
  }

  initializeState(prevProps) {
    if (!this.hasChanges(this.props, prevProps)) {
      return
    }
    this.setState(this.initialState, () => {
      setTimeout(() => this.start(), 100)
    })
  }

  hasChanges(props1, props2) {
    if (props1.rowKey && props2.rowKey) {
      return props1.rowKey !== props2.rowKey
    }
    return this.hasRowChanges(props1.row, props2.row)
  }

  hasRowChanges(row1, row2) {
    if (row1.length !== row2.length) {
      return true
    }
    return row1.some((elem, index) => elem !== row2[index])
  }

  updateFocus(prevState) {
    const actives = Object.entries(this.state.choice || {})
      .filter((c) => c[1].active)
      .map((c) => c[0])
    const prevActives = Object.entries(prevState.choice || {})
      .filter((c) => c[1].active)
      .map((c) => c[0])
    if (
      actives.length === prevActives.length &&
      actives.length === 1 &&
      actives[0] === prevActives[0]
    ) {
      return
    }
    if (!this.textInputRef.current) {
      return
    }
    this.textInputRef.current.focus()
  }

  checkAndNotifyAnswersAdded(prevState) {
    const { onAnswersAdded } = this.props;
    if (!onAnswersAdded) {
      return;
    }
    if (!prevState) {
      return;
    }
    const currentAnswersCount = Object.values(this.state.choice).filter((a) => a && a.answer !== null).length;
    const prevAnswersCount = Object.values(prevState.choice).filter((a) => a && a.answer !== null).length;
    if (prevAnswersCount === currentAnswersCount) {
      return;
    }
    const answer = this.processAnswer(this.state.current, this.state.choice);
    onAnswersAdded(answer);
  }

  componentDidMount() {
    setTimeout(() => {
      this.start()
    }, 100)
  }

  start() {
    const state = this.copyState()
    state.finished = false
    state.choice = this.initializeQuestion()
    state.activities = [
      {
        time: Date.now(),
        action: ['start']
      }
    ]
    this.setState(state, () => {
      if (!this.props.onStart) {
        return
      }
      this.props.onStart()
    })
  }

  async evaluate(choice) {
    if (this.props.evaluate) {
      return await this.props.evaluate(this.props.row, choice)
    }
    const r = {}
    Object.entries(choice).forEach((c) => {
      r[c[0]] = {
        judge: c[1].answer === c[1].correct ? 'correct' : 'incorrect',
        semantic_score: c[1].answer === c[1].correct ? 1.0 : 0.0,
        grammar_score: c[1].answer === c[1].correct ? 1.0 : 0.0
      }
    })
    return r
  }

  capitalize(target, ref) {
    if (!target || target.length === 0) {
      return target
    }
    if (target === 'I') {
      return target
    }
    if (ref.match(/^[A-Z]+$/)) {
      return target.toUpperCase()
    }
    if (ref.match(/^[a-z]+$/)) {
      return target.toLowerCase()
    }
    if (ref.match(/^[A-Z][a-z]*$/)) {
      return target.charAt(0).toUpperCase() + target.substring(1).toLowerCase()
    }
    return target
  }

  evaluateCurrent() {
    this.setState(
      {
        evalerror: null
      },
      () => {
        this.evaluate(this.state.choice)
          .then((results) => {
            const state = this.copyState()
            state.evaluating = false
            Object.entries(state.choice).forEach((c) => {
              c[1].result = results[c[0]]
            })
            state.evaluated = true
            state.activities.push({
              time: Date.now(),
              action: ['evaluated', state.choice]
            })
            console.log('Answer', state)
            this.setState(state, () => {
              this.confirm(() => {
                if (!this.props.onEvaluated) {
                  return
                }
                this.props.onEvaluated(this.state.answers)
              })
            })
          })
          .catch((error) => {
            console.error('Evaluation error', error)
            const state = this.copyState()
            state.evalerror = error.toString()
            this.setState(state)
          })
      }
    )
  }

  answer(text) {
    const ctext =
      text ||
      this.capitalize(
        this.state.input,
        Object.values(this.state.choice).filter((c) => c.active)[0].correct
      )
    const state = this.copyState()
    state.dictWords = null
    state.selectedWord = null
    state.selectedChunk = null
    state.input = ''
    const active = Object.entries(state.choice).filter((c) => c[1].active)[0]
    active[1].active = false
    active[1].answer = ctext
    active[1].result = null
    active[1].answered = Date.now()
    state.activities.push({
      time: Date.now(),
      action: ['answer', ctext, active]
    })
    let first = true
    this.props.row.forEach((word, index) => {
      if (!word.includes('|')) {
        return
      }
      if (index <= active[0]) {
        return
      }
      if (first) {
        first = false
        state.choice[index].active = true
        state.choice[index].started = Date.now()
      }
    })
    if (Object.values(state.choice).filter((c) => c.active).length > 0) {
      this.setState(state, () => {
        if (this.textInputRef.current) {
          this.textInputRef.current.focus()
        }
      })
      return
    }
    // Confirming
    state.evaluating = true
    this.setState(state, () => {
      this.evaluateCurrent()
    })
  }

  confirm(callback) {
    const state = this.copyState()
    console.log('Confirm', state)
    const answer = this.processAnswer(state.current, state.choice)
    state.answers.push(answer)
    state.finished = true
    this.setState(state, callback)
  }

  processAnswer(current, choice) {
    const answer = []
    this.props.row.forEach((word, index) => {
      if (!word.includes('|')) {
        return
      }
      answer.push(choice[index])
    })
    return {
      answer: answer
    }
  }

  initializeQuestion() {
    const choice = {}
    let first = true
    this.props.row.forEach((word, index) => {
      if (!word.includes('|')) {
        return
      }
      const cands = word.split('|')
      const correct = cands[0]
      const candidates =
        cands.filter((c) => c === '*').length > 0 ? null : shuffle(cands)
      const candidate = (candidates || []).length !== 2 ? null : candidates[0]
      const c = {
        answer: null,
        candidate,
        active: false,
        correct: correct,
        candidates,
        result: null
      }
      if (first) {
        first = false
        c.active = true
        c.started = Date.now()
      }
      choice[index] = c
    })
    return choice
  }

  inputChange(ev) {
    const state = this.copyState()
    state.input = ev.target.value.trim()
    this.setState(state)
  }

  inputKeyPress(ev) {
    if (ev.key === 'Enter') {
      this.answer()
    }
  }

  answerCorrect(correct) {
    const actives = Object.values(this.state.choice || {}).filter(
      (c) => c.active
    )
    this.answer(actives[0].candidates[correct ? 0 : 1])
  }

  wordClick(word, index) {
    if (this.props.disableWordClick) {
      return
    }
    console.log('Word', word)
    const state = this.copyState()
    const wordChunks =
      (this.props.chunks || [])[this.props.rowOffset + index] || []
    state.selectedWord = index
    if (
      !state.selectedChunk ||
      state.selectedChunk.word !== this.props.rowOffset + index ||
      state.selectedChunk.candidate + 1 >= wordChunks.length
    ) {
      state.selectedChunk = {
        word: this.props.rowOffset + index,
        candidate: -1,
        words: [this.props.rowOffset + index]
      }
    } else {
      state.selectedChunk = {
        word: this.props.rowOffset + index,
        candidate: state.selectedChunk.candidate + 1,
        words: wordChunks[state.selectedChunk.candidate + 1]
      }
    }
    state.dictWords = (state.selectedChunk.words || []).map(
      (i) => this.props.row[i - this.props.rowOffset] || ''
    )
    console.log('Chunks', wordChunks, state.selectedChunk)
    this.setState(state, () => {
      this.wordsOpen(state.dictWords)
    })
  }

  closeDict() {
    const state = this.copyState()
    state.dictWords = null
    state.selectedWord = null
    state.selectedChunk = null
    this.setState(state)
  }

  chunkContains(index) {
    if (!this.state.selectedChunk) {
      return false
    }
    return (this.state.selectedChunk.words || []).includes(
      this.props.rowOffset + index
    )
  }

  resolveTranslateRequest(words) {
    if (this.props.translateRequest) {
      return this.props.translateRequest(words)
    }
    return axios.post(`${this.props.baseURL || ''}/translate`, {
      words: words.join(' ')
    })
  }

  resolveWordRequest(word) {
    if (this.props.wordRequest) {
      return this.props.wordRequest(word.toLowerCase())
    }
    return axios.get(`${this.props.baseURL || ''}/word/${word.toLowerCase()}`)
  }

  resolveJaWordRequest(word) {
    if (this.props.jaWordRequest) {
      return this.props.jaWordRequest(word.toLowerCase())
    }
    return axios.get(`${this.props.baseURL || ''}/jaword/${word.toLowerCase()}`)
  }

  googleSearch(word, callback) {
    this.recordActivity(['googlesearch', word], () => {
      if (!this.props.onGoogleSearch) {
        callback()
        return
      }
      this.props.onGoogleSearch(word, callback)
    })
  }

  enDictRequest(word) {
    this.recordActivity(['englishdictionary', word], () => {
      if (!this.props.onEnDictRequest) {
        return
      }
      this.props.onEnDictRequest(word)
    })
  }

  jaDictRequest(word) {
    this.recordActivity(['japanesedictionary', word], () => {
      if (!this.props.onJaDictRequest) {
        return
      }
      this.props.onJaDictRequest(word)
    })
  }

  jpTranslateRequest(words) {
    this.recordActivity(['translate', words], () => {
      if (!this.props.onJpTranslateRequest) {
        return
      }
      this.props.onJpTranslateRequest(words)
    })
  }

  wordsOpen(words) {
    this.recordActivity(['open', words], () => {
      if (!this.props.onWordsOpen) {
        return
      }
      this.props.onWordsOpen(words)
    })
  }

  focusInput() {
    this.closeDict()
    if (!this.props.onFocusChange) {
      return
    }
    this.props.onFocusChange()
  }

  nextClicked(e) {
    if (!this.props.onNext) {
      return
    }
    this.props.onNext(
      this.state.activities.concat([
        {
          time: Date.now(),
          action: ['next']
        }
      ])
    )
  }

  previousClicked(e) {
    if (!this.props.onPrevious) {
      return
    }
    this.props.onPrevious(
      this.state.activities.concat([
        {
          time: Date.now(),
          action: ['previous']
        }
      ])
    )
  }

  nextPageClicked(e) {
    if (!this.props.onNextPage) {
      return
    }
    this.props.onNextPage(
      this.state.activities.concat([
        {
          time: Date.now(),
          action: ['nextpage']
        }
      ])
    )
  }

  previousPageClicked(e) {
    if (!this.props.onPreviousPage) {
      return
    }
    this.props.onPreviousPage(
      this.state.activities.concat([
        {
          time: Date.now(),
          action: ['previouspage']
        }
      ])
    )
  }

  exitClicked(e) {
    if (!this.props.onExit) {
      return
    }
    this.props.onExit(
      this.state.activities.concat([
        {
          time: Date.now(),
          action: ['exit']
        }
      ])
    )
  }

  renderResultMessage() {
    const total = Object.values(this.state.choice).length
    const correct = Object.values(this.state.choice).filter(
      (c) => c.result.judge === 'correct'
    ).length
    if (this.props.resultMessage) {
      return this.props.resultMessage(correct, total)
    }
    return `${total} 問中 ${correct} 問 正解しました！`
  }

  renderHelp() {
    const message = this.props.questionMessage || '空欄に入る単語を考えよう！'
    if (this.props.disableWordClick) {
      return message
    }
    return this.state.dictWords !== null
      ? '複数回単語をタップすると句でヒント検索'
      : `${message}単語をタップするとヒントを検索`
  }

  render() {
    const actives = Object.values(this.state.choice || {}).filter(
      (c) => c.active
    )
    return (
      <div className={styles.ClozeTest}>
        {this.state.dictWords !== null && (
          <Inspector
            words={this.state.dictWords}
            onClose={() => this.closeDict()}
            onEnDictRequest={(w) => this.enDictRequest(w)}
            onJaDictRequest={(w) => this.jaDictRequest(w)}
            onJpTranslateRequest={(w) => this.jpTranslateRequest(w)}
            onGoogleSearch={(word, callback) =>
              this.googleSearch(word, callback)
            }
            onWordsOpen={(words) => this.wordsOpen(words)}
            onAdditionalLinksRequest={this.props.onAdditionalLinksRequest}
            wordRequest={(word) => this.resolveWordRequest(word)}
            jaWordRequest={(word) => this.resolveJaWordRequest(word)}
            translateRequest={(words) => this.resolveTranslateRequest(words)}
          />
        )}
        <div className={styles.StatementPanel}>
          <div className={styles.DictHelp}>{this.renderHelp()}</div>
          <p className={styles.Statement}>
            {this.props.row.map((word, index) => (
              <span key={index}>
                {index > 0 && word.split('|')[0].match(/[a-zA-Z0-9]+/) && (
                  <span
                    className={`${styles.WordSpace} ${
                      this.chunkContains(index - 1) && this.chunkContains(index)
                        ? styles.WordSelected
                        : ''
                    }`}
                  >
                    {' '}
                  </span>
                )}
                <span
                  className={
                    this.state.selectedWord === index ||
                    this.chunkContains(index)
                      ? `${styles.Word} ${styles.WordSelected}`
                      : styles.Word
                  }
                >
                  {word.includes('|') ? (
                    <span className={styles.WordInput}>
                      <span
                        onClick={(ev) => this.wordClick(word, index)}
                        className={`${styles.Word} ${styles.Question} ${
                          this.state.choice[index] &&
                          this.state.choice[index].active
                            ? styles.ActiveQuestion
                            : ''
                        } ${
                          this.state.evaluated &&
                          this.state.choice[index] &&
                          this.state.choice[index].result &&
                          this.state.choice[index].result.judge === 'correct'
                            ? styles.Correct
                            : ''
                        } ${
                          this.state.evaluated &&
                          this.state.choice[index] &&
                          this.state.choice[index].result &&
                          this.state.choice[index].result.judge === 'incorrect'
                            ? styles.Incorrect
                            : ''
                        } ${
                          this.state.evaluating && this.state.choice[index]
                            ? styles.EvaluatingWord
                            : ''
                        }`}
                      >
                        {this.state.choice[index] === undefined ||
                        (this.state.choice[index].answer === null &&
                          !(
                            this.state.choice[index].candidate !== null &&
                            this.state.choice[index].active
                          ))
                          ? '\u00A0'.repeat(
                              Math.max(
                                ...word.split('|').map((w) => w.length)
                              ) * 2
                            )
                          : this.state.choice[index].answer !== null
                          ? this.state.choice[index].answer
                          : this.state.choice[index].candidate}
                      </span>
                      {this.state.evaluated &&
                        this.state.choice[index] &&
                        this.state.choice[index].result &&
                        this.state.choice[index].correct !==
                          this.state.choice[index].answer && (
                          <span className={styles.CorrectTip}>
                            <FontAwesomeIcon icon={faCheck} />
                            {this.state.choice[index].correct}
                          </span>
                        )}
                    </span>
                  ) : (
                    <span onClick={(ev) => this.wordClick(word, index)}>
                      {word}
                    </span>
                  )}
                </span>
              </span>
            ))}
          </p>
        </div>
        <div className={styles.InputPanel}>
          {this.state.evalerror && (
            <div className={styles.EvalError}>
              回答評価時にエラーが発生しました。申し訳ありませんがネットワーク環境を確認して評価を再実行してください:
              <div>{this.state.evalerror}</div>
              <Button
                data-test-cloze-retry-evaluate
                onClick={(e) => this.evaluateCurrent()}
                variant='danger'
              >
                評価を再実行
              </Button>
            </div>
          )}
          {this.state.evaluating && !this.state.evalerror && (
            <div className={styles.Evaluating}>
              <ClipLoader />
              <div>回答を評価中です...</div>
            </div>
          )}
          {actives.length > 0 ? (
            <div className={styles.AnswerPanel}>
              {actives[0].candidates == null ? (
                <div>
                  <div className={styles.AnswerDescription}>
                    空欄にはいる単語を入力！
                  </div>
                  <Form.Control
                    data-test-cloze-free-input
                    placeholder='空欄にはいる単語'
                    inputMode='url'
                    ref={this.textInputRef}
                    value={this.state.input}
                    onChange={(ev) => this.inputChange(ev)}
                    onKeyPress={(ev) => this.inputKeyPress(ev)}
                    onFocus={(ev) => this.focusInput()}
                  />
                  <Button
                    data-test-cloze-send-answer
                    onClick={(e) => this.answer()}
                    disabled={this.state.input === ''}
                    variant='primary'
                  >
                    確定
                  </Button>
                </div>
              ) : actives[0].candidate !== null ? (
                <div>
                  <div className={styles.AnswerDescription}>
                    この単語は正しい？
                  </div>
                  <Button
                    data-test-cloze-send-correct
                    onClick={(e) => this.answerCorrect(true)}
                    variant='success'
                  >
                    正しい
                  </Button>
                  <Button
                    data-test-cloze-send-incorrect
                    onClick={(e) => this.answerCorrect(false)}
                    variant='danger'
                  >
                    間違い
                  </Button>
                </div>
              ) : (
                <div>
                  <div className={styles.AnswerDescription}>
                    空欄にはいる単語をタップ！
                  </div>
                  {actives[0].candidates.map((cand, candIndex) => (
                    <Button
                      key={`${actives[0].correct}-${candIndex}`}
                      data-test-cloze-test-answer
                      onClick={(e) => this.answer(cand)}
                      variant='light'
                    >
                      {cand}
                    </Button>
                  ))}
                </div>
              )}
            </div>
          ) : (
            ''
          )}
        </div>
        {this.state.finished && (
          <div>
            <div className={styles.QuestionResult}>
              {this.renderResultMessage()}
              文章を確認してみましょう！
            </div>
            <NextButtons
              hint={this.props.hint}
              onHintPerform={this.props.onHintPerform}
              hasPrevious={this.props.hasPrevious}
              hasNext={this.props.hasNext}
              completed={this.props.completed}
              hasPreviousPage={this.props.hasPreviousPage}
              hasNextPage={this.props.hasNextPage}
              onPreviousPage={(ev) => this.previousPageClicked(ev)}
              onNextPage={(ev) => this.nextPageClicked(ev)}
              onPrevious={(ev) => this.previousClicked(ev)}
              onNext={(ev) => this.nextClicked(ev)}
              onExit={(ev) => this.exitClicked(ev)}
            />
          </div>
        )}
      </div>
    )
  }
}

export default Test
